import { Button, Stack, Typography } from "@mui/material";
import { useTerminateChatContractMutation } from "Api/Mutations/Social/useTerminateChatContractMutation";
import { ConfirmDialog } from "Components/Shared/Dialogs/ConfirmDialog";
import { useConfirmDialog } from "Hooks/useConfirmDialog";
import { getUserInfoAsync } from "State/Auth/UserInfo/GetUserInfoState";
import { Resources, useResource } from "Translations/Resources";
import { useDispatch } from "react-redux";
import { toast } from "sonner";

const RESOURCES = Resources.Social.Terms.Terminate;

/**
 * "Ukončit Chat a komunitní funkce" — termination of the persona's Chat contract (the one accepted
 * with its first handle). The parent shows it only while the persona has a handle; after a
 * successful termination the user-info refetch makes it disappear.
 */
export const TerminateChatSection = () => {
  const { t } = useResource();
  const dispatch = useDispatch();
  const { isOpen, open, handleResult } = useConfirmDialog();

  const { mutate: terminate, isPending } = useTerminateChatContractMutation({
    onSuccess: () => {
      // The Redux user carries the handle as well (onboarding steps read it) — keep both in step.
      dispatch(getUserInfoAsync.request(undefined));
      toast.success(t(RESOURCES.Success));
    },
    onError: () => toast.error(t(Resources.Errors.RequestError)),
  });

  return (
    <Stack gap={1}>
      <Typography variant="h6">{t(RESOURCES.Title)}</Typography>
      <Typography>{t(RESOURCES.Description)}</Typography>
      <Stack direction="row" mt={2}>
        <Button
          color="error"
          variant="outlined"
          onClick={open}
          disabled={isPending}
        >
          {t(RESOURCES.Action)}
        </Button>
      </Stack>
      <ConfirmDialog
        isDestructive
        isOpen={isOpen}
        modalTitle={t(RESOURCES.ConfirmTitle)}
        modalContent={<Typography>{t(RESOURCES.ConfirmText)}</Typography>}
        confirmButtonText={t(RESOURCES.Action)}
        handleResult={handleResult(() => terminate())}
      />
    </Stack>
  );
};
